module.exports = __webpack_public_path__ + "img/ic_device_human.9c1959b7.png";